<template>
  <div class="p-wapper">
    <div class='p-head'>
      <div class="p-clear" >
      <img class="p-logo"
              src="./../../../assets/Pc/boao/logoWhite.png"
              alt>
      <ul style="display:inline-block">
        <li :class="['p-oLi', 'fl', {'p-active': index == select, 'p-oLiSix':index==5}]" v-for="(item,index) in headList" :key="index">
          <router-link :to="item.path" v-if="index !== 5">
            <img v-if="index == 3" :src="item.image" alt="" style="width:48px;height:22px;">
            {{item.name}}
          </router-link>
          <el-dropdown v-else placement="top">
            <span class="el-dropdown-link" style="font-size:14px;">
              <a href="https://byh.chinachdu.com/#/loginpanel">{{item.name}}</a>
            </span>
            <!-- <el-dropdown-menu slot="dropdown" class="select-item" placement="bottom-end"> 
              <el-dropdown-item style="text-align:center;padding:5px;color:#666;" v-for="(item,index) in addressList" :key="index">
                <a :href="item.address" style="font-size:13px;">{{item.name}}</a>
              </el-dropdown-item>
            </el-dropdown-menu> -->
          </el-dropdown>
        </li>
      </ul>
      </div>
      <p  v-if='!videoFlag' class="headOne">ABOUT CHINA’S HEALTH DOCTOR ALLIANCE</p>
      <p  v-if='!videoFlag' class="headTwo">关于中卫佰医</p>
      <img  v-if='!startFlag' class='videoStart' @click='lookVideo' src='./../../../assets/Pc/多边形1.png'>
      <video ref='video' id="videoPlay1" class='video' v-show='videoFlag' @click="pauseClick" @ended="endVideo()" >
          <source src="https://cdn2019.oss-cn-beijing.aliyuncs.com/webStatic/guanwang/%E4%B8%AD%E5%8D%AB%E4%BD%B0%E5%8C%BB%E5%AE%A3%E4%BC%A0%E7%89%87-6.7-V1.mp4" type="video/mp4" />
      </video>
    </div>
    <!-- 公司简介 -->
    <div class="p-introduction"> 
      <p class="p-title">公司简介</p>
      <img class="p-gif" src="./../../../assets/Pc/downL.gif" alt="">
      <div>
        佰医核心团队由医疗、信息技术、互联网、保险等行业资深从业者组成，有丰富的行业经验和极强的创新理念，长期深耕医疗信息化领域，不断探索互联网在医疗领域的专业化应用。<br/><br/>
        佰医不断加大在医疗信息技术方面的研发投入，始终站在医疗信息技术水平的最前沿，致力于协助医疗机构不断提高信息化技术水平。<br/><br/>
        佰医基于自身的技术实力，在全国率先推出以实体医院为支撑，以远程医疗为核心，以医联体建设和运营、互联网医院建设和运营为主要内容的医疗云平台服务。<br/><br/>
        佰医医疗云平台采用开放、共享与协作的“互联网+医联体+医院+医生”模式，畅通医院、医生与患者的信息化服务链条，在此基础上，构建远程会诊综合服务平台、医联体协同平台、互联网医院云平台、家庭医生服务平台、区域健康服务云平台。<br/><br/>
        佰医医疗云平台全面向各级医疗健康服务机构开放，各机构通过云平台实现互联互通。云平台以服务地市级三甲医院为核心，上联北上广名院及省级三甲医院，下通县级医院、乡镇级医院及社区医院、村诊所及私人诊所，畅通医疗资源在各医疗机构之间的流动，真正夯实医联体建设，切实落地分级诊疗制度，践行国家“健康中国2030”规划。<br/>
        佰医始终致力于协助医疗机构不断提高信息化技术水平，致力于构建畅通的医疗机构协作网络和医生协作网络，致力于协助各医疗主体不断提升医疗服务能力。<br/><br/>
        公司愿景：汇聚万千医生，服务千万患者。
        公司使命：促进医疗信息技术进步，构建医疗主体合作网络，增进全球医疗服务能力。
      </div>
    </div>
    <!-- 合作案例 -->
    <div class="p-case">
      <p class="p-title">合作案例</p>
      <img class="p-gif" src="./../../../assets/Pc/downL.gif" alt="">
      <PcCase></PcCase>
    </div>
    <!-- 战略合作伙伴 -->
    <el-row class="p-con-tit">
      <el-col :span="24">
        <div class="p-bg-purple">战略合作伙伴</div>
      </el-col>
    </el-row>
    <img class="p-gif" src="./../../../assets/Pc/downL.gif" alt="">
    <el-row class="p-businessPartner p-businessPartner-two">
      <el-col :span="24">
        <ul class="p-partner clearfix">
          <li v-for="(item,index) in business" :key="index">
            <img :src="item.img" >
          </li>
        </ul>
      </el-col>
    </el-row>
    <!-- 底部 -->
    <PcFooter></PcFooter>
  </div>
</template>

<script>
import PcCase from '@/components/Pc/Case.vue';
import PcFooter from '@/components/Pc/Footer.vue';
export default {
  components:{
    PcCase,
    PcFooter
  },
  data(){
    return{
      business: [
        {
          img: require("./../../../assets/Pc/footImg/Sup_yidong.png")
        },
        {
          img: require("./../../../assets/Pc/footImg/Sup_huaxiheyi.png")
        },
        {
          img: require("./../../../assets/Pc/footImg/Sup_xie.png")
        },
        {
          img: require("./../../../assets/Pc/footImg/Sup_jia.png")
        }
      ],
      headList: [
        {
          name: "首页",
          path:'/pIndex',
          index:0,
          image:''
        },
        {
          name: "系统性解决方案",
          path:'/solution',
          index:1,
          image:''
        },
        {
          name: "主要产品",
          path:'/product',
          index:2,
          image:''
        },
        {
          name: "博鳌亚洲论坛",
          path:'/homepage',
          index:3,
          image:require('./../../../assets/Pc/boao1.png')
        },
        {
          name: "关于我们",
          path:'/about',
          index:4,
          image:''
        },
        {
          name: "登录",
          path:'/',
          index:5,
          image:''
        }
      ],
      select:4,
      videoFlag: false,
      video: '',
      startFlag:false,
      addressList:[
        {
          name:'佰医平台',
          appCode:'BYH',
          address:'https://byh.chinachdu.com/#/loginpanel'
        },
        {
          name:'航天集团',
          appCode:'HYT',
          address:'https://hyt.chinachdu.com/'
        },
        {
          name:'上饶地区',
          appCode:'SRCITYYS',
          address:'https://syt.chinachdu.com/'
        },
        {
          name:'洛阳地区',
          appCode:'LYCITYYS',
          address:'https://lyt.chinachdu.com/'
        },
        {
          name:'南昌地区',
          appCode:'NCEFY',
          address:'http://ndefy.chinachdu.com/'
        },
        {
          name:'济南地区',
          appCode:'JNS',
          address:'https://jinan.chinachdu.com/'
        },
        {
          name:'上海安达医院',
          appCode:'SHAD',
          address:'https://shad.chinachdu.com/'
        },
        {
          name:'中日友好医院',
          appCode:'ZRYH',
          address:'https://zryh.chinachdu.com/'
        },
        {
          name:'渭北中心医院',
          appCode:'SJWB',
          address:'https://sjwb.chinachdu.com/'
        },
        {
          name:'铜川矿务局中心医院',
          appCode:'SJTCKW',
          address:'https://sjtckw.chinachdu.com/'
        },
        {
          name:'河南科技大学第二附属医院',
          appCode:'HKDEFY',
          address:'https://hkdefy.chinachdu.com/'
        },
        {
          name:'陕西中医院大学第二附属医院',
          appCode:'SZEFY',
          address:'https://szefy.chinachdu.com/'
        },
        {
          name:'郑州大学第一附属医院',
          appCode:'ZDYFY',
          address:'https://zdyfy.chinachdu.com/'
        },
        {
          name:'新乡市第二人民医院',
          appCode:'XXEY',
          address:'https://xxey.chinachdu.com/'
        },
        {
          name:'国药汉江医院',
          appCode:'GYHJ',
          address:'https://gyhj.chinachdu.com/'
        }
      ]
    }
  },
  methods: {
      pauseClick(){
        var video1=document.getElementById("videoPlay1");
          if(video1.paused){
              video1.play();
              this.startFlag = true
          }else{
              video1.pause();
              this.startFlag = false
          }
      },
      endVideo(){
        this.videoFlag = false
        this.startFlag = false
      },
      lookVideo(){
          this.video = document.querySelectorAll("video")[0];
          this.video.play();
          this.videoFlag= true
          this.startFlag = true
          // this.showOtherVideo();
      },
      // showOtherVideo() {
      //     let _this = this;
      //     setTimeout(() => {
      //         _this.flag = _this._video.paused;
      //         if (!_this.flag) {
      //             _this.showOtherVideo();
      //         } else {
      //             this.videoFlag = false;
      //         }
      //     }, 1000)
      // },
      open(item){
          window.open(item.linkUrl)
      }
    },
    mounted(){
      this.$router.afterEach(() => {
        window.scrollTo(0, 0)
      })
    }
}
</script>

<style lang="less" scoped>
.p-head {
    min-width: 100%;
    min-height: 590px;
    background: url('./../../../assets/Mobile/about_head.png') no-repeat;
    background-size: 100% 100%;
    background-color:linear-gradient(128deg,rgba(59,167,234,1),rgba(59,78,222,1),rgba(59,78,222,1));
    font-family:NotoSansHans-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    text-align: center;
    margin-bottom:20px;
    position: relative;
    .p-logo {
      width: 158px;
      height: 42px;
      margin: 34px 108px 0 1px;
    }
    .p-clear{
      width:1000px;
      text-align:center;
      margin:0 auto;
    }
    .headOne{
        margin-bottom:26px;
        font-size:26px;
        font-family:PangMenZhengDao;
        font-weight:400;
        padding-top: 77px;
        color:rgba(206,206,206,1);
        line-height:26px;
    }
    
    .headTwo{
        font-size:26px;
        font-family:MicrosoftYaHei-Bold;
        font-weight:bold;
        color:rgba(255,255,255,1);
        line-height:48px;
    }
    .videoStart{
        position: absolute; left: 47%; top: 51%;
        width:100px;
    }
    .p-oLi {
    display: inline-block;
    padding: 0px 10px;
    line-height: 24px;
    height: 24px;
    margin: 46px 22px 0 0;
    img{
      height:18px;
      margin-top:2px;
    }
    a {
      font-size:14px;
      color: white;
      display: block;
      font-family: PingFangSC-Regular;
      font-weight: 400;
    }
    &:nth-child(1) {
      margin:46px 36px 0 6px;
      padding-left: 0px;
    }
  }
  .p-active {
    background: white;
    border-radius: 12px;
    a {
      color: #3b6de2;
    }
  }
  .p-oLiSix {
    float: right;
    border-radius: 12px;
    background: #3442c8;
    padding: 0 22px 0 26px;
    a {
      color: #feffff;
      font-size: 16px;
    }
  }
}
// 视频
.video{
    width: 100%;
    height:100%;
    margin:50px 0;
}
.p-introduction{
  margin:0 auto;
  width:960px;
  div{
    width:736px;
    height:600px;
    line-height:24px;
    margin:0 auto;
    font-size:14px;
    text-align:left;
    padding:38px 48px 42px 42px;
    box-shadow:4px 6px 32px 0px rgba(158,183,216,0.19);
    border-radius:10px;
    background:rgba(255,255,255,1);
  }
}
.p-title{
    font-size:24px;
    color:#333;
    text-align:center;
    
  }
.p-case{
  margin:0 auto;
  width:960px;
  p{
    margin-top:72px;
  }
}
.p-gif {
  width: 30px;
  margin: 42px auto 30px;
  display: block;
}
.p-con-tit {
  width: 1000px;
  height: 40px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: center;
  line-height: 40px;
  color: rgba(102, 102, 102, 1);
  margin: 0 auto;
  margin-top:76px;
}
.p-businessPartner {
  margin-bottom: 80px;
  padding-bottom: 20px;
  width: 100%;
  color: #666;
  background-color: white;
  .p-partner {
    height: 96px;
    margin: 0 auto;
    width: 600px;
    display: flex;
    justify-content: center;
    li {
      float: left;
      width: 160px;
      height: 96px;
      margin: 0 auto;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
      &:nth-child(1){
        img{
          transform: scale(0.9);
        }
        margin-right:40px;
      }
      &:nth-child(2){
        img{
          transform: scale(1.4);
        }
      }
      &:nth-child(3){
        img{
          transform: scale(0.7);
        }
      }
      &:nth-child(4){
        img{
          transform: scale(0.9);
        }
      }
    }
  }
}
.el-dropdown-link{
  color:#fff;
}
.el-dropdown-menu{
  min-width:180px!important;
}
</style>
